export const COMPLETED_ALT_TEXT = 'Completed'
